// GIS 在整个页面只加载一次；加载失败后允许用户主动重试。
let sdkPromise;
export function loadGoogleIdentity() {
  if (window.google?.accounts?.id) return Promise.resolve(window.google.accounts.id);
  if (!sdkPromise) {
    sdkPromise = new Promise((resolve, reject) => {
      const script = document.createElement("script");
      const finish = (error) => {
        window.clearTimeout(timer);
        script.onload = script.onerror = null;
        if (error) {
          script.remove();
          sdkPromise = null;
          reject(error);
        } else {
          resolve(window.google.accounts.id);
        }
      };
      const timer = window.setTimeout(() => finish(new Error("Google 服务连接超时，请检查网络后重试")), 15000);
      script.src = "https://accounts.google.com/gsi/client";
      script.async = true;
      script.onload = () => finish(window.google?.accounts?.id ? null : new Error("Google 登录组件加载失败"));
      script.onerror = () => finish(new Error("无法连接 Google，请检查网络或使用其他登录方式"));
      document.head.appendChild(script);
    });
  }
  return sdkPromise;
}
